<template>
  <div class="header_container">
    <div class="header-left">
      <div class="header">
        <span v-if="!slots.title">
          <n-ellipsis
            :style="{ maxWidth: `${1100 / 191}rem` }"
            class="title_ellipsis"
            :tooltip="{ style: `max-width: ${1100 / 191}rem` }"
          >
            {{ title ? title : lableTitle }}
          </n-ellipsis>
        </span>
        <slot name="title"></slot>
      </div>
      <slot name="left"></slot>
    </div>
    <slot name="right"></slot>
  </div>
</template>

<script lang="ts" setup>
import { useSlots } from 'vue';
import { useRoute } from 'vue-router';
const route = useRoute();
const { lableTitle } = route.meta;
const slots = useSlots();
defineProps({
  title: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.header_container {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.header-left {
  display: flex;
  align-items: center;
}
.header {
  color: #262626;
  font-size: 24px;
  font-weight: 700;
  line-height: normal;
  position: relative;
  min-width: 100px;
  &::before,
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    height: 4px;
  }

  &::after {
    left: 0;
    width: 72px;
    background-color: #572df3;
  }

  &::before {
    left: 72px;
    width: 28px;
    background-color: #ffa201;
  }
}
.title_ellipsis {
  width: 800px;
}
</style>
